// treeManagementSlice.js
// Здесь будет описание редьюсера treeManagementSlice

export default function treeManagementSlice(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
